export default "__VITE_ASSET__c2c4bd8a__"